<template>
	<div class="flex place-self-start items-center gap-2">
		<Switch v-model="stage.active" label="events.stages.active"/>
		<slot name="switches"/>
	</div>
	<LabeledObject required>
		<template #label>{{ trans('general.title') }}</template>
		<input v-model="stage.title" type="text" required>
	</LabeledObject>
	<div class="grid grid-cols-1 md:grid-cols-2 gap-3">
		<LabeledObject required full>
			<template #label>{{ trans('events.stages.begins_at') }}</template>
			<IconDateTimeInput v-model="stage.begins_at" icon-class="fa-solid fa-hourglass-start" required full/>
		</LabeledObject>
		<LabeledObject required full>
			<template #label>{{ trans('events.stages.ends_at') }}</template>
			<IconDateTimeInput v-model="stage.ends_at" icon-class="fa-solid fa-hourglass-end" required full/>
		</LabeledObject>
	</div>
	<slot/>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {ref, type Ref, defineProps} from 'vue'
import Switch from '@/Components/UI/Switches/Switch.vue'
import {type Stage} from '@/Types/Events/Stages/Stage'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import IconDateTimeInput from '@/Components/UI/Inputs/IconDateTimeInput.vue'

const props = defineProps<{
	stage: Stage,
}>()

const stage:Ref<Stage> = ref(props.stage)
</script>